var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":"mini"},on:{"change":_vm.onChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.doctor_id,attrs:{"value":item.doctor_id,"label":item.true_name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }